import React, {Component} from "react";
import config from 'react-global-configuration';

class PosbillFilter extends Component {
    state = {
        is_posbillinput: false,
    };
    componentDidMount(){

    }
    resetPosbillFilter() {
        this.setState({
            is_posbillinput: 0,
        })
    }

    handleCheckPosBill(e){
        var is_posbillinput = 1;
        if (e.target.checked === true) {
            this.setState({is_posbillinput: 1})
        } else {
            this.setState({is_posbillinput: 0});
            is_posbillinput = 0;
        }
        this.props.onSelectPosbill(is_posbillinput);
    }
    render() {
        return (
        <label>
            <input type="checkbox" name="is_posbillinput" onChange={this.handleCheckPosBill.bind(this)}
            checked={(this.state.is_posbillinput == 1) ? true : false}/> &nbsp;  POSBILLINPUT </label>
        );

    }
}
export default PosbillFilter;